import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@/components/ui/Button/Button';
import Dialog from '@/components/ui/Dialog/Dialog';
import { LOCAL_STORAGE_KEYS } from '@/constants/localStorageKeys';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '@/helpers/localStorage';

import {
  B2bImage,
  ButtonWrapper,
  DialogContent,
  IconWrapper,
  Text,
} from './B2B.style';

/**
 * B2B modal component.
 */
const B2B = () => {
  const [isClosed, setIsClosed] = useState(true);

  useEffect(() => {
    const showModal =
      getLocalStorageItem(LOCAL_STORAGE_KEYS.B2B_MODAL_CLOSED) !== true;
    if (showModal) {
      setIsClosed(false);
    }
  }, []);

  const handleClose = () => {
    setLocalStorageItem(LOCAL_STORAGE_KEYS.B2B_MODAL_CLOSED, true);
    setIsClosed(true);
  };

  if (isClosed) {
    return null;
  }

  return (
    <div>
      <Dialog
        open={!isClosed}
        mobileMenu={false}
        PaperProps={{
          sx: {
            maxWidth: 506,
            height: 500,
          },
        }}>
        <DialogContent data-test-subject="b2b-modal">
          <IconWrapper>
            <B2bImage />
          </IconWrapper>
          <Text>
            <FormattedMessage id="b2b_text" />
          </Text>
          <ButtonWrapper>
            <Button
              size="large"
              data-test-subject="button-close-b2b"
              fullWidth
              onClick={handleClose}>
              <FormattedMessage id="b2b_cta" />
            </Button>
          </ButtonWrapper>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default B2B;
